import { connect } from 'react-redux';
import CreateTemplate from '../components/CreateTemplate'
import { imageUpload } from '../actions';

const mapStateToProps = (state, ownProps) => {
  return {
    uploadedImage: state.imageUpload,
    ...ownProps
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    imageDataHandler: (data) => {
      dispatch(imageUpload(data));
    },
  };
};


const CreateTemplateContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateTemplate);

export default CreateTemplateContainer;
